import { START_LOADER, STOP_LOADER } from "../types";

export function loading(state = { count: 0 }, action) {
  switch (action.type) {
    case START_LOADER: {
      return { ...state, count: state.count + 1 };
    }
    case STOP_LOADER: {
      return { ...state, count: Math.max(0, state.count - 1) };
    }
    default: {
      return state;
    }
  }
}
